import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import {
  Alert,
  Box,
  CircularProgress,
  IconButton,
  LinearProgress,
} from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useGetCustomerByIdQuery } from "../../store/services/customerService";
import { useEffect } from "react";
import { usePostAddVisitMutation } from "../../store/services/crmApi";
import CustomerHero from "../../components/customer-profile/components/CustomerHero";

const CustomerPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const {
    data: customer,
    isLoading,
    isFetching,
    error,
  } = useGetCustomerByIdQuery(id ?? skipToken);

  const [addVisitedProfile] = usePostAddVisitMutation();
  useEffect(() => {
    const addVisit = async () => {
      if (id) {
        try {
          await addVisitedProfile({ customerId: id }).unwrap();
        } catch (error) {
          console.error("Error adding visit:", error);
        }
      }
    };
    return () => {
      addVisit();
    };
  }, [addVisitedProfile, id]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        bgcolor="background.default"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={3} width="100%" bgcolor="background.default">
        <Alert
          severity="error"
          action={
            <IconButton
              color="inherit"
              size="small"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
          }
        >
          Kunde inte hitta kunden. Försök igen senare.
        </Alert>
      </Box>
    );
  }

  if (!customer) {
    return (
      <Box p={3} width="100%" bgcolor="background.default">
        <Alert
          severity="warning"
          action={
            <IconButton
              color="inherit"
              size="small"
              onClick={() => navigate(-1)}
            >
              <ArrowBackIcon />
            </IconButton>
          }
        >
          Kunden kunde inte hittas.
        </Alert>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        mx: { xs: -2, sm: -3, md: -4 },
        my: -3,
        bgcolor: "#fdfdfd",
        minHeight: "100vh",
      }}
    >
      <CustomerHero customer={customer} />
      {isFetching && <LinearProgress />}
      <Box
        component="main"
        sx={{
          flex: 1,
          width: "100%",
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Box sx={{ p: { xs: 2, sm: 3 }, maxWidth: 1320, mx: "auto" }}>
          <Outlet context={{ customer }} />
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerPage;
